import type { FC } from 'react';
import styled from 'styled-components';
import type { Match, WrestlerInMatch } from '../../../types';
import { BoxSixWrestlersContainer, BoxWinnerGeneric, DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender from './GenericComponentMatchCard';

const BoxTeamContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    width: calc(50% - 60px);

    &.box-team-container.left {
        justify-content: flex-start;
    }

    &.box-team-container.right {
        justify-content: flex-end;

        & .box-names-team {
            align-items: flex-end;
            text-align: end;
        }
    }
`;

const BoxAvatars = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 80px;
    height: 90px;
`;

const BoxSingleAvatar = styled.div`
    width: 50%;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba(163, 27, 27, 0.85);
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

const BoxNamesTeam = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: calc(100% - 100px);
    padding: 0 10px;

    & h6 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        text-transform: uppercase;
        width: 100%;
    }
`;

interface SixTagMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const SixTagMatchCard: FC<SixTagMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    // prendo props.match.wrestlers_by_team e lo divido in due array uguale.. se dispari, il primo array avra' un elemento in più
    const teamsWrestlers = matchInfo.wrestlers_by_team || [];
    const teamWrestlers1 = teamsWrestlers.slice(0, Math.ceil(teamsWrestlers.length / 2));
    const teamWrestlers2 = teamsWrestlers.slice(Math.ceil(teamsWrestlers.length / 2));

    // Renderizza un singolo team wrestler
    const renderSingleTeamWrestler = (teamWrestler: WrestlerInMatch[], key: number, side: 'left' | 'right') => {
        if (side === 'left') {
            return (
                <BoxTeamContainer key={key} className={`box-team-container${side}`}>
                    <BoxAvatars>
                        {teamWrestler.map((wrestler, idx) => (
                            <BoxSingleAvatar
                             key={idx}
                             onClick={() => navigateToWrestler(wrestler)}
                            >
                                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                            </BoxSingleAvatar>
                        ))}
                        {teamWrestler[0].pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-w-100">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </BoxAvatars>
                    <BoxNamesTeam className="box-names-team">
                        {teamWrestler.map((wrestler, idx) => (
                            <h6 key={idx}> {wrestler.name}</h6>
                        ))}
                    </BoxNamesTeam>
                </BoxTeamContainer>
            );
        } else {
            return (
                <BoxTeamContainer key={key} className={`box-team-container ${side}`}>

                    <BoxNamesTeam className="box-names-team">
                        {teamWrestler.map((wrestler, idx) => (
                            <h6 key={idx}> {wrestler.name}</h6>
                        ))}
                    </BoxNamesTeam>

                    <BoxAvatars>
                        {teamWrestler.map((wrestler, idx) => (
                            <BoxSingleAvatar key={idx} onClick={() => navigateToWrestler(wrestler)}>
                                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                            </BoxSingleAvatar>
                        ))}
                        {teamWrestler[0].pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-w-100">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </BoxAvatars>

                </BoxTeamContainer>
            );
        }
    };

    // JSX
    return (
        <DefaultContainerCard>
            <TopDecorColor />

            <BoxSixWrestlersContainer className="box-six-wrestlers-container-left">
                {teamWrestlers1.map((teamWrestler, key) => (
                    renderSingleTeamWrestler(teamWrestler, key, 'left')
                ))}
            </BoxSixWrestlersContainer>

            <CenterInfoFightComponentRender
                className="center-info-fight-component-render-six"
                nameMatch="Six Tag"
                matchInfo={matchInfo}
            />

            <BoxSixWrestlersContainer className="box-six-wrestlers-container-right">
                {teamWrestlers2.map((teamWrestler, key) => (
                    renderSingleTeamWrestler(teamWrestler, key, 'right')
                ))}
            </BoxSixWrestlersContainer>
        </DefaultContainerCard>
    );
};

export default SixTagMatchCard;
